import React from "react";

function Search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      className="icon w-5 h-5"
      viewBox="0 0 256 256"
    >
      <g fill="currentColor">
        <path
          d="M192 112a80 80 0 11-80-80 80 80 0 0180 80z"
          opacity="0.2"
        ></path>
        <path d="M229.66 218.34l-50.06-50.06a88.21 88.21 0 10-11.32 11.31l50.06 50.07a8 8 0 0011.32-11.32zM40 112a72 72 0 1172 72 72.08 72.08 0 01-72-72z"></path>
      </g>
    </svg>
  );
}

export default Search;
